<template>
  <div>
    <div class="logo"></div>
    <div class="login-regist">
      <div @click='seleteRouter(index)' :class="{'active': index === nowIndex}" :key='index' v-for='(item,index) in routerList'>{{item}}</div>
    </div>
    <div @keydown.enter='login' class="about-login" v-if='!nowIndex'>
      <div class="account">
        <input maxlength="11" v-model='account' onkeyup="value=value.replace(/[^\d]/g,'')" placeholder='请输入手机号' type="text" />
      </div>
      <div class="password">
        <input v-model='passwd' placeholder='请输入密码' type="password" />
      </div>
      <div class="forget" @click='forgetPassword'>忘记密码</div>
      <p class="wrong"></p>
      <button class="login-button" @click="login">登录</button>
    </div>
    <div @keydown.enter='regist' id='regist' v-if='nowIndex' class="about-regist">
      <div class="telphone">
        <input maxlength="11" v-model='registAccount' onkeyup="value=value.replace(/[^\d]/g,'')" placeholder='请输入手机号' type="text" />
        <span>+86</span>
      </div>
      <div class="confirm">
        <div class="confirm-left">
          <input maxlength="4" v-model='registCode' onkeyup="value=value.replace(/[^\d]/g,'')" placeholder='请输入验证码' type="text" />
        </div>
        <button :disabled="disabled" class="get-confirm" @click="getCode">{{time}}</button>
      </div>
      <div class="r-password">
        <input placeholder='请输入密码' v-model='registPasswd' type="password" />
      </div>
      <p class="wrong"></p>
      <button class="login-button" @click="regist">注册</button>
    </div>  
  </div>
</template>
<script type="text/javascript">
  import { apiUrl } from '../apiUrl.js'
  import { eventBus } from '../eventBus.js'
  export default {
    data() {
      return {
        routerList: ['登录','注册'],
        nowIndex: 0,
        account: '',//登录账号
        passwd: '',//登录密码
        registAccount: '',//注册账号
        registCode: '',//注册验证码
        registPasswd: '',//注册密码
        disabled: false,
        count: 60,
        time: '获取验证码',
        timer: null
      }
    },
    methods: {
      login() {
        var phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if(!phoneReg.test(this.account)) {
          this.$message.error('请输入正确的手机号码！');
        }else if(this.passwd.length < 6 || this.passwd.length > 20) {
          this.$message.error('密码为6-20位!');
        }else {
          var mobileLoginUrl = apiUrl + 'api/user/mobileLogin?mobile=' + this.account + '&passwd=' + this.passwd
          this.axios.post(mobileLoginUrl)
          .then((res) => {
            if(res.data.code == 200) {
              eventBus.$emit('close-dialog',res.data.data.uname)
              localStorage.setItem('account',this.account)
              this.account = ''
              this.passwd = ''
              localStorage.setItem('loginInfo',JSON.stringify(res.data.data))
            }else {
              this.$message.error(res.data.msg);
            }
          })
        }
      },
      getCode() {
        var phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if(!phoneReg.test(this.registAccount)) {
          this.$message.error('请输入正确的手机号码！');
        }else {
          var sendMsmUrl = apiUrl + 'api/sms/sendMsm?mobile=' + this.registAccount
          this.axios.post(sendMsmUrl)
          .then((res) => {
            if(res.data.code == 200) {
              this.disabled = true
              this.count = 60
              this.time = this.count + 'S'
              this.timer = setInterval(() => {
                this.count--
                this.time = this.count + 'S'
                if(this.count == 0) {
                  clearInterval(this.timer)
                  this.count = 60
                  this.disabled = false
                  this.time = '重新获取验证码'
                }
              },1000)
            }else {
              this.$message.error(res.data.msg);
            }
          })
        }
      },
      regist() {
        if(!this.registAccount) {
          this.$message.error('请输入手机号码！');
        }else if(!this.registCode) {
          this.$message.error('请输入验证码');
        }else if(this.registPasswd.length < 6 || this.registPasswd.length > 20) {
          this.$message.error('密码为6-20位!');
        }else {
          var mobileRegistUrl = apiUrl + 'api/sms/mobileRegist?mobile=' + this.registAccount + '&code=' + this.registCode + '&passwd=' + this.registPasswd + '&source=4'
          this.axios.post(mobileRegistUrl)
          .then((res) => {
            if(res.data.code == 200) {
              clearInterval(this.timer)
              this.nowIndex = 0
              this.account = ''
              this.passwd = ''
            }else {
              this.$message.error(res.data.msg);
            }
          })
        }
      },
      seleteRouter(index) {
        if(this.nowIndex == 0) {
          this.registAccount = ''
          this.registCode = ''
          this.registPasswd = ''
          this.disabled = false
          clearInterval(this.timer)
          this.count = 60
          this.time = '获取验证码'
        }else {
          this.account = ''
          this.passwd = ''
        }
        this.nowIndex = index
      },
      forgetPassword() {
        eventBus.$emit('forget-passwd')
      }
    }
  }
</script>
<style scoped>
  .logo {
    display: block;
    width: 93px;
    height: 93px;
    margin: 0 auto 34px;
    background: url(../assets/72.png) 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 20px 0 20px 0;
    box-shadow: 0 0 20px 0 #ddd;
  }
  .login-regist {
    display: flex;
    justify-content: space-between;
    height: 28px;
    width: 180px;
    margin: 0 auto 20px;
  }
  .login-regist div,.login-regist span {
    display: block;
    width: 50px;
    height: 18px;
    padding-bottom: 8px;
    cursor: pointer;
    font-size: 18px;
    line-height: 18px;
    color: #333;
    text-align: center;
    border-bottom: 2px solid #fff;
  }
  .login-regist .active {
    color: #40c0c0;
    border-color: #40c0c0;
  }
  .account input,.password input,.r-password input,.reset-tel input,.r-r-password input {
    display: block;
    width: 282px;
    height: 40px;
    padding-left: 48px;
    margin-bottom: 16px;
    border: none;
    outline: none;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    background: url(../assets/19.png) 20px center no-repeat;
    background-size: 17px 20px;
  }
  .password input,.r-password input {
    background: url(../assets/20.png) 19px center no-repeat;
    background-size: 19px 22px;
  }
  .forget {
    display: block;
    height: 14px;
    margin-bottom: 10px;
    cursor: pointer;
    text-decoration: none;
    font-size: 14px;
    line-height: 14px;
    text-align: right;
    color: #777777;
  }
  .forget:hover {
    color: #40c0c0;
  }
  .login-button,.regist-button,.reset-button,.reset-button1 {
    display: block;
    width: 332px;
    height: 40px;
    margin: 0 auto;
    padding: 0;
    border: none;
    outline: none;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #40c0c0;
    border-radius: 5px;
  }
  .telphone {
    position: relative;
  }
  .telphone input {
    display: block;
    width: 258px;
    height: 40px;
    padding-left: 72px;
    margin-bottom: 16px;
    border: none;
    outline: none;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
  }
  .telphone span {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 51px;
    height: 40px;
    display: block;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    color: #777;
    border-right: 1px solid #d0d0d0;
  }
  .confirm,.r-confirm {
    width: 332px;
    height: 42px;
    margin-bottom: 16px;
  }
  .confirm-left,.r-confirm-left {
    float: left;
  }
  .confirm-left input,.r-confirm-left input {
    width: 113px;
    padding-left: 51px;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    border: none;
    outline: none;
    color: #333;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    background: url(../assets/21.png) 20px center no-repeat;
    background-size: 17px 21px;
  }
  .get-confirm,.r-get-confirm {
    float: right;
    display: block;
    width: 136px;
    height: 42px;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    color: #fff;
    background: #40c0c0;
    border: none;
    outline: none;
    border-radius: 3px;
  }
  input:hover {
    border-color: #40c0c0;
  }
  input[type="text"]:focus, 
  input[type="password"]:focus { 
    border-color: #40c0c0;
  }
</style>


// WEBPACK FOOTER //
// src/components/login.vue